/**
 * Reine Helfer fuer die CSV-Erzeugung. Kein React, keine Netzwerkzugriffe,
 * damit die Logik ohne Rendering testbar bleibt.
 *
 * Zwei Profile, weil eine CSV nicht gleichzeitig fuer deutsches Excel und fuer
 * einen RFC-Parser passen kann. EXCEL trennt mit Semikolon, STANDARD mit Komma.
 * Das BOM steht immer davor, ohne es zeigt Excel Umlaute als Mojibake, und die
 * einzigen Leidtragenden waeren Skripte, die mit utf-8 statt utf-8-sig lesen.
 */

export const CSV_PROFILES = { EXCEL: 'excel', STANDARD: 'standard' }

const DELIMITERS = { [CSV_PROFILES.EXCEL]: ';', [CSV_PROFILES.STANDARD]: ',' }

const BOM = '﻿'
const NEWLINE = '\r\n'

// Excel fuehrt Zellen aus, die mit einem dieser Zeichen beginnen. Bewerbertext
// aus den Zusatzfeldern geht ungeprueft in die Datei, deshalb ist das Pflicht.
const FORMULA_START = /^[=+\-@\t\r]/
const PLAIN_NUMBER = /^-?\d+([.,]\d+)?$/

export const getDelimiter = (profile) =>
  DELIMITERS[profile] || DELIMITERS[CSV_PROFILES.STANDARD]

// Das Profil folgt der Oberflaechensprache. Ein fest verdrahtetes Semikolon
// waere fuer eine englische Locale genauso falsch wie das bisherige Komma fuer
// die deutsche.
export const defaultProfileForLanguage = (language) =>
  language === 'de' ? CSV_PROFILES.EXCEL : CSV_PROFILES.STANDARD

const escapeForRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Wert in eine CSV-Zelle verwandeln.
 *
 * @param {*}      value
 * @param {string} delimiter Das aktive Trennzeichen, es geht in die Quoting-Regel ein.
 * @returns {string}
 */
export const toCsvField = (value, delimiter = ',') => {
  if (value === undefined || value === null) return ''

  let text = String(value)

  if (FORMULA_START.test(text) && !PLAIN_NUMBER.test(text)) {
    text = `'${text}`
  }

  const needsQuotes = new RegExp(`["\n\r${escapeForRegExp(delimiter)}]`)

  return needsQuotes.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

/**
 * @param {Object} input
 * @param {Array<string>} input.headers
 * @param {Array<Array<*>>} input.rows
 * @param {string} [input.profile]
 * @returns {string} Der Dateiinhalt inklusive BOM.
 */
export const buildCsv = ({
  headers,
  rows,
  profile = CSV_PROFILES.STANDARD
}) => {
  const delimiter = getDelimiter(profile)
  const line = (cells) =>
    cells.map((cell) => toCsvField(cell, delimiter)).join(delimiter)

  return BOM + [headers, ...rows].map(line).join(NEWLINE) + NEWLINE
}

/**
 * Datei im Browser anbieten. Das revokeObjectURL fehlte bisher, bei vielen
 * Spalten haelt ein Export sonst mehrere Megabyte bis zum Reload fest.
 */
export const downloadCsv = ({ content, filename }) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' })
  const objUrl = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.setAttribute('href', objUrl)
  link.setAttribute('download', `${filename}.csv`)
  link.click()

  setTimeout(() => URL.revokeObjectURL(objUrl), 0)
}
